import React, { useEffect } from 'react';
import { useAuthStore } from '../store/useAuthStore';
import { useCallHistoryLoader } from '../hooks/useCallHistoryLoader';
import MiniCallList from './MiniCallList';

// Eigenständige Mini-Ansicht unter #/mini — für Browser ohne Document-PiP wird sie
// als kleines Popup-Fenster geöffnet und lädt/aktualisiert selbstständig.

export default function MiniView() {
  const { warmingTick } = useCallHistoryLoader();
  const company = useAuthStore((s) => s.company);

  useEffect(() => {
    document.title = `${company?.name ?? 'eves_MDR'} – Anrufhistorie`;
  }, [company]);

  return (
    <>
      {warmingTick > 0 && (
        <div className="px-3 py-1 small text-info-emphasis bg-info-subtle d-flex align-items-center gap-2">
          <span className="spinner-border spinner-border-sm" style={{ width: 11, height: 11 }} />
          Zeitraum wird geladen — aktualisiert sich automatisch.
        </div>
      )}
      <MiniCallList />
    </>
  );
}
